module.exports = __webpack_public_path__ + "img/flag-pennant.4400be41.svg";